import '../plugins/timezone'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../plugins/axios'
window.wx = require('weixin-js-sdk');
import StarRating from 'vue-star-rating'
import { Button, Switch, Cell, Field, DatetimePicker, Picker, Popup, Navbar, TabItem, TabContainer, TabContainerItem } from 'mint-ui'
Vue.component('star-rating', StarRating);
Vue.component(Switch.name, Switch)
Vue.component(Button.name, Button)
Vue.component(Cell.name, Cell)
Vue.component(Field.name, Field)
Vue.component(DatetimePicker.name, DatetimePicker)
Vue.component(Picker.name, Picker)
Vue.component(Popup.name, Popup)
Vue.component(Navbar.name, Navbar)
Vue.component(TabItem.name, TabItem)
Vue.component(TabContainer.name, TabContainer)
Vue.component(TabContainerItem.name, TabContainerItem)
// import vConsole from 'vconsole'
// var vc = new vConsole();
Vue.config.productionTip = false
// window.Vue = Vue
window.defaultStore = store
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'cn',
  messages: {
    cn: require('../i18n/cn.js'),
    en: require('../i18n/en.js')
  }
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')